var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5436_10411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1797 30.375H60.8984C60.4883 30.375 60.0781 30.7852 60.0781 31.1953C60.0781 31.2637 60.0781 31.2637 60.0781 31.2637L60.3516 36.9375C57.2754 33.2461 52.627 30.9219 47.5 30.9219C38.1348 30.9219 30.4785 38.5781 30.5469 47.9434C30.5469 57.3086 38.1348 64.8281 47.5 64.8281C51.875 64.8281 55.8398 63.1875 58.8477 60.5215C58.9844 60.3164 59.1211 60.1113 59.1211 59.9062C59.1211 59.6328 58.9844 59.4277 58.8477 59.291L56.5234 56.9668C56.3867 56.8301 56.1816 56.7617 55.9766 56.7617C55.7715 56.7617 55.5664 56.8301 55.4297 56.9668C53.3105 58.8125 50.5078 59.9062 47.5 59.9062C40.8008 59.9062 35.4688 54.5742 35.4688 47.875C35.4688 41.2441 40.8008 35.8438 47.5 35.8438C51.6016 35.8438 55.293 37.9629 57.4805 41.1758L50.5078 40.834C50.5078 40.834 50.5078 40.834 50.4395 40.834C50.0293 40.834 49.6191 41.2441 49.6191 41.6543H49.6875V44.9355C49.6875 45.3457 50.0293 45.7559 50.5078 45.7559H64.1797C64.5898 45.7559 65 45.3457 65 44.9355V31.1953C65 30.7852 64.5898 30.375 64.1797 30.375Z",
    fill: "#606B71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5436_10411",
    x: 0.478516,
    y: 0.375,
    width: 94.5215,
    height: 94.4531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.329412 0 0 0 0 0.529412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5436_10411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5436_10411",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.eb91d181.svg";
export { ForwardRef as ReactComponent };